// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_d6-3";
export var flatBottomCorners = "_d6-5";
export var productImage = "_d6-0";
export var quantityContainer = "_d6-2";
export var quantityHeader = "_d6-6";
export var tooltip = "_d6-1";
export var wrapAndEllipsesOverflow = "_d6-4";